<section class="page-wrap animated fadeIn position-relative pb-5rem">

  <header class="pattern-header">
    How It Works
  </header>

  <p class="h6-regular text-center m-0">
    Shopping for local, farm fresh food has never been so quick & easy. <strong>No subscriptions, no
      obligations!</strong>
  </p>

  <div class="content-story">
    <div class="container how">

      <div class="how__step how__step--hide how__step--left">
        <img src="/assets/images/landing/home/how-it-works/icon.svg" alt="Tag icon">
        <span>1</span>
      </div>

      <div class="how__row">

        <div class="step1">

          <div class="how__step how__step--show how__step--left">
            <img src="/assets/images/landing/home/how-it-works/icon.svg" alt="Tag icon">
            <span>1</span>
          </div>

          <h2 class="how__title">
            Sign Up
          </h2>

          <!-- <p class="h6-regular text-center">
            Shopping for local, farm fresh food has never been so quick & easy. <strong>No subscriptions, no
              obligations!</strong>
          </p> -->

          <p class="h6-regular text-center">
            <a [routerLink]="['/signup']">Sign up here</a> to create a Carlton Farms account. Enter a delivery address
            to get your farm fresh goods delivered to your door or office building.
          </p>

          <p class="h6-regular text-center">
            We also have several <strong>drop-off or popup pickup locations around the greater Atlanta metro
              area</strong>. Though we do ask you to input your credit card information, registration is free and you
            won't be charged until you place your first order.
          </p>

        </div>

        <img class="how__mobile-img" src="/assets/images/landing/how/rectangle-cows.webp"
          alt="Three brown and white cows with ear tags standing inside a barn.">

        <img class="how__right-img" src="/assets/images/landing/how/cows.webp"
          alt="Three brown and white cows with ear tags standing inside a barn.">

      </div>

      <div class="how__step how__step--hide how__step--left">
        <img src="/assets/images/landing/home/how-it-works/icon.svg" alt="Tag icon">
        <span>2</span>
      </div>

      <div class="how__row">

        <img class="how__left-img" src="/assets/images/landing/how/tomatoes.webp"
          alt="Two hands holding a bowl of freshly picked tomatoes." />

        <div class="step2">

          <div class="how__step how__step--show">
            <img src="/assets/images/landing/home/how-it-works/icon.svg" alt="Tag icon">
            <span>2</span>
          </div>

          <h2 class="how__title">
            Fill your Basket
          </h2>

          <p class="h6-regular text-center">
            After you have signed up, <strong>it's time to start shopping!</strong> We carry a large selection of
            farm-fresh foods for
            you to choose from; including everything from pasture-raised meats, wild-caught fish, raw dairy products,
            pastured eggs, organic fruits and vegetables, and all-natural pantry products, cultured products, raw honey
            & personal care, all from <strong>local sources.</strong>
          </p>

          <p class="h6-regular text-center">
            Orders can be placed for individual orders or recurring weekly orders.
          </p>

        </div>

        <img class="how__mobile-img" src="/assets/images/landing/how/rectangle-tomatoes.webp"
          alt="Two hands holding a bowl of freshly picked tomatoes." />

      </div>

      <div>

        <div class="how__step">
          <img src="/assets/images/landing/home/how-it-works/icon.svg" alt="Tag icon">
          <span>3</span>
        </div>

        <h2 class="how__title">
          Delivered
        </h2>

        <p class="h6-regular text-center mb-0">
          Home Delivery, Pop-Up Pick-Up, or Drop-off
        </p>

        <p class="h6-regular text-center">
          Your account will be charged the evening before delivery.
        </p>

      </div>

      <div class="text-center mt-5">
        <span class="h3-regular is-tertiary-font text-primary">
          Thanks
        </span>
        <p class="h3-bold">
          For the privilege of being your farmer.
        </p>
        <button class="btn btn-primary" type="button" [routerLink]="['/signup']">
          Get Started now!
        </button>
      </div>

    </div>
  </div>

  <div class="container">
    <footer class="footer">
      <p class="h7-regular mb-0">
        There is no commitment with your Carlton Farms account. You can change your delivery location, drop-off, or
        mobile market location as
      </p>
      <p class="h7-regular">
        well as the frequency of your orders at any time in your account settings.
      </p>
    </footer>
  </div>

  <img class="bottom-img" src="/assets/images/landing/how/chicken.webp" alt="A brown hen standing on grass.">

</section>
